"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "4.0.28";



//////////////////
// WEBPACK FOOTER
// ./node_modules/ethers/_version.js
// module id = 1433
// module chunks = 0